import { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';

export default function StripePaymentStep({ amount, onSuccess, onBack, loading: externalLoading }) {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState('');
  const [processing, setProcessing] = useState(false);

  const displayAmount = (amount / 100).toFixed(2);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;
    setError('');
    setProcessing(true);

    const { error: submitError } = await elements.submit();
    if (submitError) { setError(submitError.message); setProcessing(false); return; }

    const { error: confirmError, paymentIntent } = await stripe.confirmPayment({
      elements,
      redirect: 'if_required',
    });

    if (confirmError) {
      setError(confirmError.message);
      setProcessing(false);
    } else if (paymentIntent && paymentIntent.status === 'succeeded') {
      onSuccess(paymentIntent.id);
    } else {
      setError('Payment did not complete. Please try again.');
      setProcessing(false);
    }
  };

  const busy = processing || externalLoading;

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ background: 'var(--light-blue)', border: '1px solid rgba(0,56,147,0.2)', borderRadius: 8, padding: '12px 16px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 10 }}>
        <i className="fas fa-lock" style={{ color: 'var(--primary-blue)' }}></i>
        <span style={{ color: 'var(--dark-blue)', fontSize: '0.9rem' }}>Secure payment powered by Stripe</span>
        <strong style={{ marginLeft: 'auto', color: 'var(--dark-blue)' }}>${displayAmount} AUD</strong>
      </div>

      <PaymentElement options={{
        layout: 'accordion',
        terms: {
          card: 'never',
          auBecsDebit: 'never',
          bancontact: 'never',
          ideal: 'never',
          sepaDebit: 'never',
          sofort: 'never',
          usBankAccount: 'never',
        },
        wallets: { applePay: 'never', googlePay: 'never' },
      }} />

      {error && (
        <div style={{ background: '#fff3f3', border: '1px solid #ffcccc', borderRadius: 8, padding: '12px 16px', marginTop: 12, color: 'var(--primary-red)', fontSize: '0.9rem' }}>
          <i className="fas fa-exclamation-circle" style={{ marginRight: 8 }}></i>{error}
        </div>
      )}

      <div style={{ display: 'flex', gap: 12, marginTop: 20 }}>
        <button
          type="button"
          onClick={onBack}
          disabled={busy}
          style={{ padding: '12px 24px', borderRadius: 32, border: '2px solid var(--primary-blue)', background: 'transparent', color: 'var(--primary-blue)', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
        >
          <i className="fas fa-arrow-left"></i> Back
        </button>
        <button
          type="submit"
          disabled={!stripe || busy}
          className="btn-mncw"
          style={{ flex: 1, justifyContent: 'center' }}
        >
          {busy
            ? <><i className="fas fa-spinner fa-spin"></i> Processing…</>
            : <><i className="fas fa-lock"></i> Pay ${displayAmount} AUD</>}
        </button>
      </div>
    </form>
  );
}
